import {RoomProtocolMapperClient} from '../../shared/scripts/RoomProtocolMapperClient.ts'
import {UIMSceneEnum} from '../../../shared/enums/UIMSceneEnums.ts'
import {RoomClientState} from '../../shared/scripts/RoomClientState.ts'
import {clientI18n} from '../../shared/scripts/ClientI18n.ts'
import {LobbyImage} from '@colonist/types'
import {UIMManager} from './ui_html/UIMManager.ts'
import {notificationController} from '../../shared/scripts/EntryShared.ts'
import {convertChatResponseToText, convertFailedToSendReasonToChatData} from '../../shared/scripts/RoomChatUtils.ts'

export function registerMobileRoomClientHandlers(roomClient: RoomProtocolMapperClient, uiManager: UIMManager) {
    roomClient.onRoomStateUpdated((roomState: RoomClientState) => {
        if(uiManager.sceneController.scene == UIMSceneEnum.Game) window.location.reload()
        uiManager.mainpageController.headerController.notificationPanelController?.hideNotificationPanel()
        uiManager.createRoomController.updateRoomState(roomState)
    })

    roomClient.onGotKicked(() => {
        notificationController.showNotification(LobbyImage.Lightning, {key: 'strings:roomPage.notifications.youWereKickedFromRoom'})
        uiManager.createRoomController.leaveRoom()
        uiManager.fullscreenPageController.closeAllPages()
    })

    roomClient.onReceivedChatMessage((message, senderSessionId) => {
        uiManager.createRoomController.receivedChatMessage(message, senderSessionId)
    })

    roomClient.onFailedToSendChatMessage((reason, mutedUntil) => {
        const reasonText = convertFailedToSendReasonToChatData(reason, mutedUntil)
        const text = clientI18n.t(reasonText.key, reasonText.options)
        uiManager.createRoomController.receivedChatSystemMessage(text)
    })

    roomClient.onReceivedChatResponse((response) => {
        for(const responseText of convertChatResponseToText(response)) {
            const text = clientI18n.t(responseText.key, responseText.options)
            uiManager.createRoomController.receivedChatSystemMessage(text)
        }
    })

    roomClient.onKickedInactiveHost(() => {
        uiManager.createRoomController.onKickedInactiveHost()
    })
}
